import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { ModalGestionarSolicitud } from "./ModalGestionarSolicitud";
import {
  setActiveStep,
  setAfiliadoSeleccionado,
  setShowForm,
  setSolicitud,
  setMedicamentos,
  setDiagnosticos,
  setearSolicitudTomada,
  liberarSolicitudTomada
} from "../../../actions/empadronamiento/Empadronamiento";
import { STEPPER_EMPADRONAMIENTO } from "../../../utils/constants";
import { DiagnosticoItem } from "../gestionEmpadronamiento/DiagnosticoItem";
import { MedicamentoItem } from "../gestionEmpadronamiento/MedicamentoItem";
import { ModalHistorialCambiosEmp } from "../gestionEmpadronamiento/ModalHistorialCambiosEmp";
import InfoHistorialIcon from "../../autorizaciones/UI/InfoHistorialIcon";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const SolicitudItemConsulta = (props) => {
  const dispatch = useDispatch();
  const { item } = props;
  const [open, setOpen] = useState(props.expandirMedicamentos);
  const [openDiag, setOpenDiag] = useState(props.expandirDiagnosticos);
  const [openModalGestionar, setOpenModalGestionar] = useState(false);
  const [openModalHistorialCambios, setOpenModalHistorialCambios] = useState(false);

  const classes = useRowStyles();

  const postRetomarSolicitud = (item) => {
    dispatch(setearSolicitudTomada(item, setearSolicitud));
  }

  const postAutorizarSolicitud = (item) => {
    dispatch(setearSolicitudTomada(item, setearSolicitud));
  }

  const postLiberarSolicitud = (item) => {
    dispatch(liberarSolicitudTomada(item, setearSolicitud));
  }

  const setearSolicitud = (item) => {
    dispatch(setSolicitud(item));
    dispatch(setDiagnosticos(item));
    dispatch(setMedicamentos(item));
    dispatch(setAfiliadoSeleccionado(item.afiliado));
    dispatch(setShowForm(true));
    dispatch(setActiveStep(STEPPER_EMPADRONAMIENTO.DETALLE));
    props.setRedirect(true);
  }

  return (
    <>
      {openModalGestionar && (
        <ModalGestionarSolicitud
          open={openModalGestionar}
          closeModalHandler={() => {
            setOpenModalGestionar(false);
          }}
          postRetomarSolicitud={postRetomarSolicitud}
          setOpenModalGestionar={setOpenModalGestionar}
          postAutorizarSolicitud={postAutorizarSolicitud}
          postLiberarSolicitud={postLiberarSolicitud}
        />
      )}
      {openModalHistorialCambios && (
        <ModalHistorialCambiosEmp
          open={openModalHistorialCambios}
          closeModalHandler={() => {
            setOpenModalHistorialCambios(false);
          }}
          solicitud={item}
          titulo={`Empadronamiento N° ${item.idSolicitud}`}
        />
      )}
      <TableRow className={classes.root} >
        <TableCell align="center" sx={{padding: "10px"}}>
          <InfoHistorialIcon onClick={() => setOpenModalHistorialCambios(true)} />
        </TableCell>
        <TableCell align="left">{new Date(item.fechaInicio).toLocaleString("es", optionsfecha)} </TableCell>
        <TableCell align="left">{item.fechaFin !== null ? new Date(item.fechaFin).toLocaleString("es", optionsfecha) : new Date('2099-12-31').toLocaleString("es", optionsfecha)} </TableCell>
        <TableCell align="left">{item.idSolicitud}</TableCell>
        <TableCell align="left">{item.tipoEmpadronamiento.descripcion}</TableCell>
        <TableCell>
          {item.diagnosticos?.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpenDiag(!openDiag)}
            >
              {openDiag ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell>
          {item.medicamentos?.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell align="left">{item.afiliado?.apellido_y_nombre}</TableCell>
        <TableCell align="left">{item.afiliado?.carnet}</TableCell>
        <TableCell>
          <Button
            style={{ fontSize: "0.8rem" }}
            variant="contained"
            color="primary"
            onClick={() => {
              setOpenModalGestionar(true);
              dispatch(setSolicitud(item));
            }}
          >
            Ver
          </Button>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 20 }}
          colSpan={6}
        >
          <Collapse in={openDiag} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Diagnósticos
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Descripción</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {item.diagnosticos?.map((diagnostico) => (
                    <DiagnosticoItem
                      key={diagnostico?.idDiagnostico?.toString()}
                      item={diagnostico}
                    />
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 20 }}
          colSpan={11}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Medicamentos
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Presentación</TableCell>
                    <TableCell>Laboratorio</TableCell>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Drogas</TableCell>
                    <TableCell align="right">Cantidad</TableCell>
                    <TableCell>Dosis</TableCell>
                    <TableCell>Posología</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {item.medicamentos?.map((medicamento) => (
                    <MedicamentoItem
                      key={medicamento?.idMedicamento?.toString()}
                      item={medicamento}
                    />
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
